import React from "react";
import { useSelector } from "react-redux";

export const StylesTemplate = () => {
    const {
        color_cont,
        text_lat_hover,
        // color_lat,
        color_nav,
        color_text_menu,
        text_lat,
        color_lat_hover,
        text_nav,
        text_cont,
        color_text_header_nav,
        color_text_menu_accordion,
        color_text_menu_accordion_hover,
    } = useSelector((state) => state.config);

    const css = `
                html, body {
                    background-color: ${color_nav};
                    color: ${text_cont} !important;
                }

                .c-app{
                    background-color: ${color_nav};
                }

                .c-default-layout {
                    background-color: ${color_cont};
                }

                /* Sidebar nav links e iconos */
                .c-sidebar-nav-link {
                    color: ${color_text_menu} !important;
                }

                .c-sidebar-nav-link:hover {
                    color: ${color_text_menu_accordion_hover} !important;
                    background: ${color_lat_hover} !important;
                }

                .c-sidebar-nav-icon {
                    color: ${color_text_menu} !important;
                }

                .c-sidebar-nav-title {
                    color: ${text_lat} !important;
                }

                .c-sidebar .c-sidebar-nav-link:hover .c-sidebar-nav-icon {
                    color: ${text_lat_hover} !important;
                }

                /* Enlace activo en menú lateral */
                .activeNavLinkApp {
                    background: ${text_lat} !important;
                }

                .activeNavLinkApp a,
                .activeNavLinkApp i {
                    color: ${text_nav} !important;
                }

                .color_text_app{
                    color: ${color_text_menu} !important;
                }

                /* Colores de textos */
                .c-header-nav-link label {
                    color: ${color_text_header_nav} !important;
                }

                label {
                    color: ${text_cont} !important;
                }
 `;

    return <style>{css}</style>;
};
